import { Component, OnInit, ViewChild } from '@angular/core';
import { NavParams, PopoverController, ToastController } from '@ionic/angular';
import { DataManagementService } from '../../../data-management/data-management.service';
import { Subscription } from 'rxjs';
import { Vehicule, Group } from 'src/app/model/data-managemnt';
import { RealTimeRecord } from 'src/app/model/real-time';
import { SearchStepperComponent } from 'src/app/shared/components/search-stepper/search-stepper.component';
import { HistoricalService } from '../../historical.service';
import { GeocodingService } from 'src/app/utils/leaflet/service/geocoding.service';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';
import { RealTimeService } from 'src/app/pages/realtime/realtime.service';

@Component({
  selector: 'app-stop-modal',
  templateUrl: './stop-modal.component.html',
  styleUrls: ['./stop-modal.component.scss'],
})
export class StopModalComponent implements OnInit {
  modalTitle: string;
  modelId: number;
  groups: Group[];
  selectedGroup: Group = new Group();
  selectedVehicule: Vehicule | null;
  AllGroups: Subscription;
  AllStops: Subscription;
  @ViewChild(SearchStepperComponent, { static: false }) calendarModalComponent: SearchStepperComponent;

  constructor(
    private popoverController: PopoverController, private toastController: ToastController,
    private navParams: NavParams, public historicalService: HistoricalService,
    public dataManagementService: DataManagementService, private realTimeService: RealTimeService,
    private geocodingService: GeocodingService, private realTimeWorker: RealtimeWorkerService
  ) { }

  ngOnInit() {
    this.modelId = this.navParams.data.paramID;
    this.modalTitle = this.navParams.data.paramTitle;

    if (this.dataManagementService.groups) {
      this.groups = this.dataManagementService.groups.filter(
        group => group.vehicules.length > 0
      );
      if (this.dataManagementService.selectedGroup) {
        this.selectedGroup = this.dataManagementService.selectedGroup;
        if (this.dataManagementService.selectedVehicule) {
          this.selectedVehicule = this.dataManagementService.selectedVehicule;
        } else if (this.selectedGroup.vehicules.length > 0) {
          this.selectedVehicule = this.selectedGroup.vehicules[0];
        }
      } else {
        if (this.groups.length > 0 && this.groups) {
          this.selectedGroup = this.groups[0];
          this.dataManagementService.selectedGroup = this.selectedGroup;
        }
      }
      this.selectedVehicule = this.dataManagementService.selectedVehicule;
    } else {
      this.AllGroups = this.dataManagementService
        .getAllGroupsDetails("")
        .subscribe(groups => {
          this.groups = groups;
          this.groups.forEach(group => {
            group.vehicules.forEach(vehicule => {
              vehicule.realTimeRecord = new RealTimeRecord();
              this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(x => {

                vehicule.realTimeRecord = x;

              }, (err) => {

              });
            });
          });

          this.groups = groups.filter((group: any) => group.vehicules.length > 0);
          this.dataManagementService.groups = groups;
          if (this.groups.length > 0 && this.groups) {
            this.selectedGroup = this.groups[0];
            this.dataManagementService.selectedGroup = this.selectedGroup;
            if (this.selectedGroup && this.selectedGroup.vehicules.length > 0) {
              this.selectedVehicule = this.selectedGroup.vehicules[0];
              this.dataManagementService.selectedVehicule = this.selectedVehicule;
            }
          }
        });
    }
  }


  chooseVehicule(vehicule: any) {
    this.selectedVehicule = vehicule;
    this.dataManagementService.setSelectedVehicle(vehicule, this.selectedGroup);
    this.realTimeWorker.applyHistoriqueVehicleSelection(vehicule, this.selectedGroup);
  }

  chooseGroup(group: any) {
    this.dataManagementService.selectedGroup = group;
    this.selectedGroup = group;
    if (this.selectedGroup.vehicules.length > 0 && this.selectedGroup) {
      this.selectedVehicule = this.selectedGroup.vehicules[0];
      this.dataManagementService.setSelectedVehicle(this.selectedVehicule, group);
      this.realTimeWorker.applyHistoriqueVehicleSelection(this.selectedVehicule, group);
    }
  }
  async closePopover() {
    await this.popoverController.dismiss(undefined, 'search-done', 'historique-search-popover').catch(() => undefined);
  }

  getAllStops() {
    this.AllStops = this.historicalService
      .getAllStops(this.selectedVehicule!.device.idDevice, {
        startDate: this.calendarModalComponent.startDate,
        endDate: this.calendarModalComponent.endDate
      })
      .subscribe(
        stops => {
          if (stops && stops.length) {
            this.toastController.dismiss(
              this.dataManagementService.getVehiculeName(
                this.selectedVehicule!
              ) +
              " a effectuer " +
              stops.length +
              " arrêts entre " +
              (this.calendarModalComponent.startDate, "dd/MM/yyyy HH:mm:ss") +
              " et " +
              (this.calendarModalComponent.endDate, "dd/MM/yyyy HH:mm:ss")
            );

            this.historicalService.stops = this.historicalService.sortByDateDesc(stops, s => s.beginStopTime);
            this.historicalService.startDate = new Date(this.calendarModalComponent.startDate);
            this.historicalService.endDate = new Date(this.calendarModalComponent.endDate);
            this.dataManagementService.setSelectedVehicle(this.selectedVehicule, this.selectedGroup);
            this.realTimeWorker.applyHistoriqueVehicleSelection(this.selectedVehicule, this.selectedGroup);
            this.historicalService.stopsLoadedForDeviceId = this.selectedVehicule?.device?.idDevice
              ?? this.selectedVehicule?.idDevice
              ?? null;

            this.historicalService.stops.forEach(stop => {
              stop.geocodingDetails = this.dataManagementService.getRelativePosition(
                stop.stopLatitude,
                stop.stopLongitude
              );
              stop.geocoding = stop.geocodingDetails;
              stop.beginStopTime = stop.beginStopTime;
              if (stop.geocodingDetails == null) {
                this.geocodingService
                  .inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 17)
                  .subscribe(
                    adress => {
                      stop.geocoding = this.geocodingService.proccessingNomitamAddress(
                        adress
                      );
                      stop.geocodingDetails = stop.geocoding;
                    },
                    err => {
                      stop.geocodingDetails = null;
                      stop.geocoding = null;
                    }
                  );
              }
            });
          }
        },
        err => {
        }
      );
  }

  async onValidate() {
    this.getAllStops();
    await this.closePopover();
  }
}

